/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ng2-toastr/src/toast-container.component';
import * as i3 from '@angular/platform-browser';
import * as i4 from 'ng2-toastr/src/toast-options';
const styles_ToastContainer:any[] = ([] as any[]);
export const RenderType_ToastContainer:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ToastContainer,data:{'animation':[{type:7,name:'inOut',definitions:[{type:0,
        name:'flyRight, flyLeft',styles:{type:6,styles:{opacity:1,transform:'translateX(0)'},
            offset:(null as any)},options:(undefined as any)},{type:0,name:'fade',
        styles:{type:6,styles:{opacity:1},offset:(null as any)},options:(undefined as any)},
        {type:0,name:'slideDown, slideUp',styles:{type:6,styles:{opacity:1,transform:'translateY(0)'},
            offset:(null as any)},options:(undefined as any)},{type:1,expr:'void => flyRight',
            animation:[{type:6,styles:{opacity:0,transform:'translateX(100%)'},offset:(null as any)},
                {type:4,styles:(null as any),timings:'0.2s ease-in'}],options:(null as any)},
        {type:1,expr:'flyRight => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateX(100%)'},offset:(null as any)},timings:'0.2s 10ms ease-out'}],
            options:(null as any)},{type:1,expr:'void => flyLeft',animation:[{type:6,
            styles:{opacity:0,transform:'translateX(-100%)'},offset:(null as any)},
            {type:4,styles:(null as any),timings:'0.2s ease-in'}],options:(null as any)},
        {type:1,expr:'flyLeft => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateX(-100%)'},offset:(null as any)},timings:'0.2s 10ms ease-out'}],
            options:(null as any)},{type:1,expr:'void => fade',animation:[{type:6,
            styles:{opacity:0},offset:(null as any)},{type:4,styles:(null as any),
            timings:'0.3s ease-in'}],options:(null as any)},{type:1,expr:'fade => void',
            animation:[{type:4,styles:{type:6,styles:{opacity:0},offset:(null as any)},
                timings:'0.3s 10ms ease-out'}],options:(null as any)},{type:1,expr:'void => slideDown',
            animation:[{type:6,styles:{opacity:0,transform:'translateY(-200%)'},offset:(null as any)},
                {type:4,styles:(null as any),timings:'0.3s ease-in'}],options:(null as any)},
        {type:1,expr:'slideDown => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateY(-200%)'},offset:(null as any)},timings:'0.3s 10ms ease-out'}],
            options:(null as any)},{type:1,expr:'void => slideUp',animation:[{type:6,
            styles:{opacity:0,transform:'translateY(200%)'},offset:(null as any)},
            {type:4,styles:(null as any),timings:'0.3s ease-in'}],options:(null as any)},
        {type:1,expr:'slideUp => void',animation:[{type:4,styles:{type:6,styles:{opacity:0,
            transform:'translateY(200%)'},offset:(null as any)},timings:'0.3s 10ms ease-out'}],
            options:(null as any)}],options:{}}]}});
function View_ToastContainer_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'toast-close-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.removeToast((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['×\n        ']))],
      (null as any),(null as any));
}
function View_ToastContainer_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',((<any>_v.parent).context.$implicit.config.titleClass || _co.titleClass),
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.title;
    _ck(_v,1,0,currVal_1);
  });
}
function View_ToastContainer_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'span',([] as any[]),
      [[8,'className',0],[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',((<any>_v.parent).context.$implicit.config.messageClass || _co.messageClass),
        '');
    const currVal_1:any = _co.sanitizer.bypassSecurityTrustHtml((<any>_v.parent).context.$implicit.message);
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_ToastContainer_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      [[8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',((<any>_v.parent).context.$implicit.config.messageClass || _co.messageClass),
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.message;
    _ck(_v,1,0,currVal_1);
  });
}
function View_ToastContainer_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),17,'div',([] as any[]),
      [[24,'@inOut',0],[8,'className',0]],[[(null as any),'@inOut.done'],[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('@inOut.done' === en)) {
          const pd_0:any = ((<any>_co.onAnimationEnd($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.clicked(_v.context.$implicit)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastContainer_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),[' \n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastContainer_3)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),8,'div',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(16384,
          (null as any),0,i1.NgSwitch,([] as any[]),{ngSwitch:[0,'ngSwitch']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n          '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ToastContainer_4)),i0.ɵdid(278528,(null as any),
          0,i1.NgSwitchCase,[i0.ViewContainerRef,i0.TemplateRef,i1.NgSwitch],{ngSwitchCase:[0,
              'ngSwitchCase']},(null as any)),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastContainer_5)),
      i0.ɵdid(16384,(null as any),0,i1.NgSwitchDefault,[i0.ViewContainerRef,i0.TemplateRef,
          i1.NgSwitch],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n        '])),(_l()(),i0.ɵted((null as any),['             \n      ']))],
      (_ck,_v) => {
        const currVal_2:any = _v.context.$implicit.config.showCloseButton;
        _ck(_v,3,0,currVal_2);
        const currVal_3:any = _v.context.$implicit.title;
        _ck(_v,6,0,currVal_3);
        const currVal_4:any = _v.context.$implicit.config.enableHTML;
        _ck(_v,9,0,currVal_4);
        const currVal_5:any = true;
        _ck(_v,12,0,currVal_5);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.animate;
        const currVal_1:any = i0.ɵinlineInterpolate(1,'toast toast-',_v.context.$implicit.type,
            '');
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
export function View_ToastContainer_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,[['toastContainer',
      1]],(null as any),4,'div',[['id','toast-container']],[[4,'position',(null as any)],
      [8,'className',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ToastContainer_1)),i0.ɵdid(802816,(null as any),
          0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    var _co:i2.ToastContainer = _v.component;
    const currVal_2:any = _co.toasts;
    _ck(_v,4,0,currVal_2);
  },(_ck,_v) => {
    var _co:i2.ToastContainer = _v.component;
    const currVal_0:any = _co.position;
    const currVal_1:any = i0.ɵinlineInterpolate(1,'',_co.positionClass,'');
    _ck(_v,1,0,currVal_0,currVal_1);
  });
}
export function View_ToastContainer_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'toast-container',
      ([] as any[]),(null as any),(null as any),(null as any),View_ToastContainer_0,
      RenderType_ToastContainer)),i0.ɵdid(180224,(null as any),0,i2.ToastContainer,
      [i3.DomSanitizer,i0.ChangeDetectorRef,i0.NgZone,i4.ToastOptions],(null as any),
      (null as any))],(null as any),(null as any));
}
export const ToastContainerNgFactory:i0.ComponentFactory<i2.ToastContainer> = i0.ɵccf('toast-container',
    i2.ToastContainer,View_ToastContainer_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/node_modules/ng2-toastr/src/toast-container.component.ngfactory.ts